import { FlatActionList } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { ProductFormValues } from "../../types";
import { Switch } from "react-native";
import { compact } from "lodash";
import { useTranslation } from "../../../../../../utilities/i18n";

export interface SerialNumbersFieldsetProps {
  onManageSerialNumbersPress?: () => void;
}

export const SerialNumbersFieldset = ({
  onManageSerialNumbersPress,
}: SerialNumbersFieldsetProps) => {
  const { t } = useTranslation("product");
  const { control, watch } = useFormContext<ProductFormValues>();
  const id = watch("id");

  const watchedGlobalDisable = watch("globalDisable");

  const commonProps = {
    disabled: watchedGlobalDisable,
  };

  return (
    <View>
      <FlatActionList
        items={[
          ...compact([
            onManageSerialNumbersPress &&
              id && {
                key: "manageSerialNumbers",
                ...commonProps,
                title: t("action.manage_serial_numbers.title"),
                subTitle: t("action.manage_serial_numbers.subtitle"),
                onPress: onManageSerialNumbersPress,
              },
          ]),
          {
            key: "serialNumbers",
            ...commonProps,
            title: t("form.serial_numbers_sale.label"),
            subTitle: t("form.serial_numbers_sale.description"),
            onPress: () => {},
            componentRight: () => (
              <Controller
                name="serialNumbersSale"
                control={control}
                {...commonProps}
                render={({ field: { onChange, value, disabled } }) => (
                  <View>
                    <Switch
                      value={value}
                      disabled={disabled}
                      onValueChange={() => {
                        onChange(!value);
                      }}
                    />
                  </View>
                )}
              />
            ),
          },
          {
            key: "serialNumbersArr",
            ...commonProps,
            title: t("form.serial_numbers_arrival.label"),
            subTitle: t("form.serial_numbers_arrival.description"),
            onPress: () => {},
            componentRight: () => (
              <Controller
                name="serialNumbersArr"
                {...commonProps}
                control={control}
                render={({ field: { onChange, value, disabled } }) => (
                  <View>
                    <Switch
                      value={value}
                      disabled={disabled}
                      onValueChange={() => {
                        onChange(!value);
                      }}
                    />
                  </View>
                )}
              />
            ),
          },
        ]}
      />
    </View>
  );
};
